require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/fn/symbol/iterator.js
// module id = 111
// module chunks = 1